/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
//import {getAchUrlAsync}  from './DataActionExtension.g';
/**
 * GetAchurl Input Action
 */

export class GetAchUrlInput implements Msdyn365.IActionInput {
    public PaymentData:string;
    // TODO: Construct the input needed to run the action
    constructor() {
        this.PaymentData='';
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `TODO`;
    public getCacheObjectType = () => 'TODO';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetAchUrlData {
    secret: string;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetAchUrlInput();
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(input: GetAchUrlInput, ctx: Msdyn365.IActionContext): Promise<IGetAchUrlData> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;

    // TODO: Uncomment the below line to get the value from a service
    const response = await Msdyn365.sendRequest<IGetAchUrlData>('https://tmc-comret.sandbox.operations.dynamics.com/Commerce/GetAchUrl', 'post', '{paymentData: "yy"}');
    //return getAchUrlAsync({ callerContext: ctx, bypassCache:'get' }, 'wow').then(response=>{
    //    return { secret: response};
    //});
    //return response;
    return { secret:response.statusText};
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetAchUrlData>>action,
    // TODO: Give your data action a unique id
    id: 'GetAchUrl',
    input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
